import Vue from 'vue'
import locale from 'element-ui/lib/locale';
import VueI18n from 'vue-i18n'

import zh from './langs/zh'
import en from './langs/en'
import tc from './langs/tc'

import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'

Vue.use(VueI18n)

const messages = {
    en: Object.assign(en, enLocale),
    zh: Object.assign(zh, zhLocale),
    tc: Object.assign(tc, twLocale),
}

// var localeInBrowser = navigator.language || navigator.userLanguage
// console.log("locale now is " + localeInBrowser)
var defaultLocale = 'zh'
// if (localeInBrowser === 'zh-CN') {
//     defaultLocale = 'zh'
// }
const i18n = new VueI18n({
    locale: localStorage.getItem('locale') || defaultLocale,
    messages,
    silentTranslationWarn: true,
})

locale.i18n((key, value) => i18n.t(key, value))
// console.log('%c当前缓存语言是：'+(localStorage.getItem('locale')=='en'?'English':'中文')+'','color:#fff;background:green;padding:4px;border-radius:5px');
window.i18n = i18n
if (i18n.locale === 'zh') {
    window.document.title = "小飞鼠RPA帮助中心"
} else if (i18n.locale === 'tc') {
    window.document.title = "小飛鼠RPA幫助中心"
} else {
    window.document.title = "RPA Help Center"
}
export default i18n